var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("SearchBarController", [
    "$scope",
    "$q",
    "$filter",
    "configs",
    "$timeout",
    "elasticService",
    "urlService",
    "searchSuggestionSpriteService",
    function (
        $scope,
        $q,
        $filter,
        configs,
        $timeout,
        elasticService,
        urlService,
        searchSuggestionSpriteService
    ) {
        //#region Properties
        var searchTimer;
        $scope.searchTerm = "";
        $scope.headerSearch = false;
        $scope.suggestedProducts = [];
        $scope.suggestedTerms = [];
        $scope.suggestedCategoryList = [];
        $scope.suggestedBrandList = [];
        $scope.searchDefinitionName = "all";
        $scope.searchURL = "";
        $scope.highlightedItemIndex = -1;
        $scope.filterLimit = 5;
        var latestSuggestRequestId = 0;
        var promotionRulesCache = null;
        //#endregion

        //#region Functions

        $scope.getProductUrl = function (definitionName, vendor, name, id) {
            return urlService.getProductUrl({
                definitionName: definitionName,
                catalogId: vendor,
                name: name,
                sku: id,
            });
        };

        $scope.getImageUrl = function (definitionName, vendor, prdId) {
            vendor = vendor.replace(/ /g, "_");
            return urlService.getImageUrl({
                definitionName: definitionName,
                size: "large",
                catalogId: vendor,
                sku: prdId,
            });
        };

        $scope.getSuggestionIconStyle = function (suggestion) {
            return searchSuggestionSpriteService.getSuggestionIconStyle(suggestion);
        };

        $scope.suggest = function () {
            $timeout.cancel(searchTimer);
            // Debounce suggestion API calls.
            searchTimer = $timeout(function () {
                var trimmedTerm = ($scope.searchTerm || "").trim();
                if (trimmedTerm !== "" && trimmedTerm.length >= 3) {
                    $scope.showNoresults = false;

                    var requestId = ++latestSuggestRequestId;
                    $scope.applySearchBackground(true);

                    $q.all([
                        $scope.httpGetSuggestedTerms().catch(function () {
                            return {};
                        }),
                        $scope.httpGetSuggestedProducts().catch(function () {
                            return {};
                        }),
                        $scope.httpGetsuggestedBrandList().catch(function () {
                            return {};
                        }),
                        $scope.httpGetSuggestedCategoryList().catch(function () {
                            return {};
                        }),
                        loadSuggestionPromotions().catch(function () {
                            return [];
                        }),
                    ]).then(function (responses) {
                        if (requestId !== latestSuggestRequestId) {
                            return;
                        }

                        var termsResponse = responses[0] || {};
                        var productsResponse = responses[1] || {};
                        var brandsResponse = responses[2] || {};
                        var categoriesResponse = responses[3] || {};
                        var promotionRules = responses[4] || [];
                        var customSuggestion = {};

                        $scope.suggestedTerms =
                            (((termsResponse.suggest || {}).keywordSuggest || [])[0] || {})
                                .options || [];
                        $scope.suggestedProducts =
                            (((productsResponse.hits || {}).hits) || []);
                        $scope.suggestedBrandList =
                            ((((brandsResponse.aggregations || {}).brandlist || {}).buckets) || []);
                        $scope.suggestedCategoryList =
                            ((((categoriesResponse.aggregations || {}).categoryList || {}).buckets) || []);

                        customSuggestion = getConfiguredSuggestion(
                            $scope.searchTerm,
                            promotionRules
                        );
                        if (customSuggestion) {
                            customSuggestion.isPromotion = true;
                            $scope.suggestedProducts.splice(0, 0, customSuggestion);
                        }

                        if (
                            $scope.suggestedBrandList.length > 0 ||
                            $scope.suggestedCategoryList.length > 0
                        ) {
                            $scope.filterLimit = 2;
                        } else {
                            $scope.filterLimit = 5;
                        }

                        $scope.showNoresults =
                            $scope.suggestedCategoryList.length === 0 &&
                            $scope.suggestedBrandList.length === 0 &&
                            $scope.suggestedTerms.length === 0 &&
                            $scope.suggestedProducts.length === 0;

                        if ($scope.showNoresults) {
                            $scope.applySearchBackground(false);
                        }
                    });

                    $scope.getSearchURL();
                } else {
                    latestSuggestRequestId++;
                    $scope.suggestedProducts = [];
                    $scope.suggestedTerms = [];
                    $scope.suggestedCategoryList = [];
                    $scope.suggestedBrandList = [];
                    $scope.filterLimit = 5;
                    $scope.showNoresults = false;
                    $scope.applySearchBackground(false);
                }
            }, 350);
        };

        $scope.applySearchBackground = function (isOn) {
            var bckGround = document.getElementById("backgroundSearch");
            var searchBar = document.getElementById("divSearchBar");
            if (angular.isDefined(bckGround)) {
                if (isOn) {
                    bckGround.classList.add("search-background");
                    if (document.body.clientWidth >= 1180 && angular.isDefined(searchBar)) {
                        searchBar.style.marginLeft = "-35px";
                    }
                } else {
                    bckGround.classList.remove("search-background");
                    if (angular.isDefined(searchBar)) {
                        searchBar.style.marginLeft = "0";
                    }
                }
            }
        };

        $scope.httpGetSuggestedProducts = function () {
            var deferred = $q.defer();
            var e = document.getElementById("ddlSearchDefName");
            if (angular.isDefined(e)) {
                $scope.searchDefinitionName = e.value;
            } else {
                $scope.searchDefinitionName = "all";
            }
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedProductsRequest(
                        getElasticSuggestQueryText($scope.searchTerm),
                        $scope.searchDefinitionName,
                        ($scope.searchTerm || "").trim()
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetSuggestedTerms = function () {
            var deferred = $q.defer();
            elasticService
                .getKeywordsElasticData(
                    elasticService.buildSuggestedTermsRequest(
                        getElasticSuggestQueryText($scope.searchTerm)
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetSuggestedCategoryList = function () {
            var deferred = $q.defer();
            var categorySearchTerm = getFacetSearchTerm($scope.searchTerm);
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedCategoriesRequest(
                        categorySearchTerm
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetsuggestedBrandList = function () {
            var deferred = $q.defer();
            var brandSearchTerm = getFacetSearchTerm($scope.searchTerm);
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedBrandsRequest(
                        brandSearchTerm
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.setSearchTerm = function (v) {
            $scope.searchTerm = $filter("lowercase")(v);
            $scope.highlightedItemIndex = -1;
            $scope.search();
        };

        $scope.changeSelection = function (event, value) {
            $scope.headerSearch = !$scope.headerSearch;
            if (value > 0) $scope.headerSearch = true;
            else $scope.headerSearch = false;
            switch (event.keyCode) {
                case 38: // Up
                    if ($scope.highlightedItemIndex > -1)
                        $scope.highlightedItemIndex--;
                    else if ($scope.highlightedItemIndex <= -1)
                        $scope.highlightedItemIndex = -1;
                    break;
                case 40: // Down
                    if (
                        $scope.highlightedItemIndex >=
                        $scope.suggestedTerms.length - 1
                    )
                        $scope.highlightedItemIndex =
                            $scope.suggestedTerms.length - 1;
                    else if (
                        $scope.highlightedItemIndex <
                        $scope.suggestedTerms.length
                    )
                        $scope.highlightedItemIndex++;
                    break;
                case 13: // Enter
                    $scope.search(event);
                    event.preventDefault();
                default:
                    break;
            }
        };

        $scope.search = function (event) {
            var normalizedSearchTerm = ($scope.searchTerm || "").trim();
            if (
                normalizedSearchTerm !== ""
            ) {
                // Check if search term has 2+ spaces (3+ words) for advanced search
                if (
                    $scope.isAdvancedSearch(normalizedSearchTerm) &&
                    window.__env &&
                    window.__env.isAdvancedSearchEnabled
                ) {
                    // Navigate to advanced search page with query parameter
                    var encodedTerm = encodeURIComponent(normalizedSearchTerm);
                    window.location = "/advsearch?searchterm=" + encodedTerm;
                    if (event && event.preventDefault) {
                        event.preventDefault();
                    }
                    return;
                }

                if ($scope.highlightedItemIndex > -1) {
                    $scope.searchTerm =
                        $scope.suggestedTerms[$scope.highlightedItemIndex].text;
                } else {
                    $scope.searchTerm = normalizedSearchTerm;
                }
                if (typeof gtag !== "undefined" && gtag !== null) {
                    gtag("event", "view_search_results", {
                        search_term: $scope.searchTerm,
                    });
                }
                $scope.getSearchURL();
                window.location = $scope.searchURL;
            }
        };

        $scope.closeSuggestions = function () {
            $scope.searchTerm = "";
            $scope.suggest();
            $scope.applySearchBackground(false);
        };

        $scope.isAdvancedSearch = function (searchTerm) {
            if (!searchTerm || searchTerm.trim() === "") {
                return false;
            }
            var tokens = searchTerm.trim().split(/\s+/);
            return tokens.length >= 3;
        };

        $scope.searchBtnClick = function (event) {
            if (
                $scope.searchTerm != null &&
                $scope.searchTerm != undefined &&
                $scope.searchTerm != ""
            ) 
                $scope.search(event);
            else {
                alert("Please enter search term");
                if (event && event.preventDefault) {
                    event.preventDefault();
                }
            }
        };

        function getElasticSuggestQueryText(raw) {
            var normalized = elasticService.normalizeProductSearchTerm(raw);
            if (normalized) {
                return normalized;
            }
            return (raw || "").toString().trim().toLowerCase();
        }

        function getFacetSearchTerm(searchTerm) {
            var normalized = elasticService.normalizeProductSearchTerm(searchTerm);
            if (!normalized) {
                return "";
            }

            var ignoredWords = {
                free: true,
                embroidery: true,
                design: true,
                designs: true,
                file: true,
                files: true,
                download: true,
                downloads: true,
                pattern: true,
                patterns: true,
            };

            var tokens = normalized
                .split(/\s+/)
                .filter(function (token) {
                    return token && !ignoredWords[token];
                });

            if (tokens.length >= 2) {
                // Use core intent terms for broader category/brand matching.
                return tokens.slice(0, 3).join(" ");
            }

            return normalized;
        }

        function loadSuggestionPromotions() {
            if (angular.isArray(promotionRulesCache)) {
                return $q.resolve(promotionRulesCache);
            }
            var payload = window.__searchSuggestionPromotionsConfig || {};
            var rules = angular.isArray(payload)
                ? payload
                : angular.isArray(payload.rules)
                ? payload.rules
                : [];
            promotionRulesCache = rules;
            return $q.resolve(rules);
        }

        function getFallbackSuggestion(normalizedTerm) {
            var svgSearchWords = ["svg", "dxf", "cuttable", "heat transfer"];
            var cdSearchWords = [
                "custom",
                "customdigitizing",
                "custom digitizing",
                "digitizing",
                "embroidery digitizing",
            ];

            if (cdSearchWords.indexOf(normalizedTerm) > -1) {
                return {
                    icon: "digitizing",
                    url: "/customdigitizing",
                    _source: {
                        brand: "Embroiderydesigns.com",
                        name: "Custom Digitizing",
                        itemId: "CD01-Custom Design",
                        definitionName: "CustomDigitizing",
                    },
                };
            }

            if (svgSearchWords.indexOf(normalizedTerm) > -1) {
                return {
                    icon: "svg",
                    url: "/printart/productlistings?ht=true",
                    _source: {
                        name: "ALL SVG Files",
                        brand: "Embroiderydesigns.com",
                        itemId: "N/A",
                        definitionName: "SVG",
                    },
                };
            }

            return null;
        }

        function getConfiguredSuggestion(searchTerm, rules) {
            var normalizedTerm = elasticService.normalizeProductSearchTerm(searchTerm);
            rules = angular.isArray(rules) ? rules : [];

            for (var i = 0; i < rules.length; i++) {
                var rule = rules[i] || {};
                if (!rule.regex || !rule.suggestion) {
                    continue;
                }

                try {
                    if (new RegExp(rule.regex, "i").test(normalizedTerm)) {
                        return angular.copy(rule.suggestion);
                    }
                } catch (e) {
                    // Ignore invalid regex and continue processing remaining rules.
                }
            }

            // Keep existing placeholders as fallback for safety.
            return getFallbackSuggestion(normalizedTerm);
        }

        $scope.getSearchListingUrl = function (term) {
            var searchText = (term || $scope.searchTerm || "").toString().trim();
            var defSlug = ($scope.searchDefinitionName || "all").toLowerCase();
            var searchTerm = encodeURIComponent(
                searchText.replace(/[\s+]/g, "-").toLowerCase()
            );
            return "/listing/" + defSlug + "/" + searchTerm;
        };

        $scope.getSearchURL = function () {
            $scope.searchURL = $scope.getSearchListingUrl($scope.searchTerm);
        };

        //#endregion
    },
]);

storefrontApp.filter("formatQueryStringWithSpace", function () {
    return function (X) {
        if (X != undefined) return X.replace(/\s/g, "-").toLowerCase();
        else return X;
    };
});
